import { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';
import { AppButton, AppTextField } from 'components';

import TablePaginate from 'components/Paginate';
import useDebounce from 'hooks/useDebounce';
import usePaginateDefaults from 'hooks/usePaginateDefaults';
import useStreamList from 'hooks/API/GET/useStreamList';
import * as AppPics from 'assets/images';
import StreamDeleteModal from './StreamDeleteModal';

import AppBreadcrumbs from 'components/molecules/AppBreadcrumbs';
import { useHistory } from 'react-router-dom';

function ListStream() {
  const history = useHistory();
  const [search, handleSearch] = useState('');
  const [params, setParams] = usePaginateDefaults();
  const searchKeyword = useDebounce(search, 1000);
  const [modalConfig, setModalConfig] = useState({ show: false, data: {} });

  const {
    isLoading,
    data: tableData,
    isError,
  } = useStreamList({
    enabled: true,
    configs: { params: { ...params, keyword: searchKeyword } },
  });

  const { meta: { page = 1, total } = {} } = tableData?.data ?? {};

  return (
    <Fragment>
      <div className="mainWraper coursetabsection">
        <div className="tab">
          <ul className="tab__menu">
            <li className="back">
              <button className="btn-back" onClick={() => history.push('/curriculum')}>
                <img src={AppPics.BackSvg} alt="Back" />
              </button>
            </li>
          </ul>

          <div className="tab__content ___adjust___tab___padding">
            <div className="tab__content-actHead">
              <AppBreadcrumbs
                links={[
                  { label: 'Dashboard', to: '/dashboard' },
                  { label: 'Curriculum', to: '/curriculum' },
                ]}
                current="Streams"
              />
            </div>
            <div className="tab__content-actBody">
              <div className="px-5 py-5">
                <div className="tab__contentMenu">
                  <ul className="tab__contentMenu-list">
                    <li>
                      <h2 className="prime-head p-0 boldtitle text-nowrap">Manage Streams</h2>
                    </li>
                  </ul>

                  <div className="mainHeader__search">
                    <ul className="tab__contentMenu-list">
                      <li className="relative">
                        <input
                          className="mainHeader__searchInput"
                          placeholder="Search Streams..."
                          type="text"
                          value={search}
                          onChange={(e) => handleSearch(e.target.value)}
                        />
                        <span className="mainHeader__searchBtn">
                          <img src={AppPics.TopMenuSearchSvg} alt="Search" />
                        </span>
                      </li>
                    </ul>
                  </div>

                  <div className="flex items-center gap-10">
                    <Link to="/manage/stream/add">
                      <button className="btn-left-content add">Add Stream</button>
                    </Link>
                  </div>
                </div>

                <div className="tableWrap mt-3">
                  <div className="table-responsive">
                    <table className="table tableWrap__table">
                      <thead className="thead-light __appTheadColor">
                        <tr>
                          <th>#</th>
                          <th className="w25">Name</th>
                          <th className="w25">Key</th>
                          <th className="w25">Status</th>
                          <th className="align-center">Actions</th>
                        </tr>
                      </thead>
                      {isLoading ? (
                        'Loading...'
                      ) : isError ? (
                        'Failed to load data'
                      ) : tableData?.data?.result?.length > 0 ? (
                        <tbody>
                          {tableData.data.result.map((result, index) => (
                            <tr key={result._id}>
                              <th scope="row">{index + 1}</th>
                              <td>{result.name}</td>
                              <td>{result.key}</td>
                              <td>{result.status}</td>
                              <td className="align-center">
                                <Link to={`/manage/stream/edit/${result._id}`} className="mx-2">
                                  <img src={AppPics.EditSvg} alt="edit" />
                                </Link>
                                <span
                                  className="cursor-pointer"
                                  onClick={() => setModalConfig({ show: true, data: result })}
                                >
                                  <img src={AppPics.DeleteSvg} alt="delete" />
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      ) : (
                        'No records found'
                      )}
                    </table>
                  </div>
                </div>

                <TablePaginate
                  maxCount={total}
                  currentPage={page}
                  defaultLimit={params.limit}
                  setPage={(page) => setParams((x) => ({ ...x, page }))}
                  handleChange={(limit) => setParams((x) => ({ ...x, page: 0, limit }))}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <StreamDeleteModal
        modalConfig={modalConfig}
        closeModal={() => setModalConfig({ show: false, data: {} })}
      />
    </Fragment>
  );
}

export default ListStream;
